import { sharedZh } from './pages/shared'
import { sendSmsZh } from './pages/sendSms'
import { dashboardZh } from './pages/dashboard'
import { smsSearchZh } from './pages/smsSearch'
import { realTimeProgressZh } from './pages/realTimeProgress'
import { exportRecordsZh } from './pages/exportRecords'
import { platformSettingsZh } from './pages/platformSettings'
import { apiKeysZh } from './pages/apiKeys'
import { apiDocsZh } from './pages/apiDocs'
import { accountZh } from './pages/account'

export default {
  lang: {
    zhCN: '简体中文',
    enUS: 'English',
    jaJP: '日本語',
    select: '语言 / Language',
  },
  menu: {
    dashboard: '数据概览',
    sendSms: '发送短信',
    realTimeProgress: '实时进度',
    pendingQueue: '待处理队列',
    smsSearch: '短信搜索',
    exportRecords: '导出记录',
    apiIntegration: '开发对接',
    apiDocs: '对接文档',
    apiKeys: '密钥与回执',
    platformSettings: '平台设置',
  },
  nav: {
    overview: '概览',
    smsService: '短信服务',
    development: '开发对接',
    developConfig: '开发与配置',
    collapseSidebar: '收起侧栏',
    efficientReach: '高效触达',
    efficientReachDesc: '全球短信秒级送达',
  },
  layout: {
    balance: 'Balance',
    accountSettings: '账户设置',
    accountSettingsDesc: '密码与邮箱管理',
    logout: '退出登录',
    logoutConfirm: '确认退出',
    logoutConfirmText: '确定要退出当前账号吗？',
    cancel: '取消',
    confirm: '确认退出',
    online: '在线',
  },
  login: {
    badge: 'Global SMS Network',
    heroTitle: '连接全球',
    heroAccent: '即时触达',
    heroDesc: '{site} 为企业提供稳定、安全、低延迟的跨境短信基础设施，覆盖 OTP、营销与通知场景。',
    statCountries: '覆盖国家',
    statUptime: '链路可用',
    statDelivery: '平均送达',
    username: '用户名',
    password: '密码',
    captcha: '验证码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    captchaPlaceholder: '请输入验证码',
    submit: '进入控制台',
    submitting: '登录中…',
    portalFail: '代登失败，请手动登录',
    required: '请输入用户名和密码',
    fail: '登录失败',
    footer: '© {year} {site}',
  },
  common: {
    loading: '加载中…',
    save: '保存',
    close: '关闭',
    search: '搜索',
    reset: '重置',
    export: '导出',
    refresh: '刷新',
    total: '共 {n} 条',
    noData: '暂无数据',
    success: '操作成功',
    failed: '操作失败',
    networkError: '网络异常，请检查连接',
    timeout: '请求超时',
    sessionExpired: '登录状态已过期',
    unknown: '未知',
  },
  badge: {
    marketing: '营销短信',
  },
  shared: sharedZh,
  sendSms: sendSmsZh,
  dashboard: dashboardZh,
  smsSearch: smsSearchZh,
  realTimeProgress: realTimeProgressZh,
  exportRecords: exportRecordsZh,
  platformSettings: platformSettingsZh,
  apiKeys: apiKeysZh,
  apiDocs: apiDocsZh,
  account: accountZh,
}
